<script>
export default {
  template: '<template></template>',
}
</script>

<style lang="scss">
@use '../../ArticleItem/ArticleItem';
@use '../../ArticleContainer/ArticleContainer';
@use '../../ArticleHeroBanner/ArticleHeroBanner';
</style>
